import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import { get } from 'lodash-es'

/**
 * 工人管理列表
 */
export const projectExternalEmployeeList = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.ProjectExternalEmployeeList}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}

/**
 * 工人管理-工人列表-新增/编辑
 */
export const insertOrUpdateProjectExternalEmployee = (data) => {
  return request(UrlConfig.plusPmWeb.InsertProjectExternalEmployee, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人管理-工人详情-离职/启用
 */
export const projectExternalEmployeeupdateById = (data) => {
  return request(UrlConfig.plusPmWeb.UpdateExtActStatusByExtEmpId, {
    method: METHODS.POST,
    data: data
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人-银行卡-银行卡添加
 */
export const addExtAccountByExtEmpId = data => {
  return request(UrlConfig.plusPmWeb.AddExtAccountByExtEmpId, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 修改银行信息
 */
export const editExtAccount = data => {
  return request(UrlConfig.plusPmWeb.EditExtAccount, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 银行卡-删除
 */
 export const deleteExtAccountById = id => {
  return request(`${UrlConfig.plusPmWeb.DeleteExtAccountById}?id=${id}`, {
    method: METHODS.POST,
  })
}
/**
 * 工人-银行卡-ID查询
 */
export const findExtAccountById = data => {
  return request(UrlConfig.plusPmWeb.findExtAccountById, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 新增合同
 */
export const saveContractProjectExternalEmployee = data => {
  return request(UrlConfig.plusPmWeb.SaveContractProjectExternalEmployee, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
export const deleteContractById = id => {
  return request(`${UrlConfig.plusPmWeb.DeleteContractById}?id=${id}`, {
    method: METHODS.POST,
  })
}
/**
 * 工人管理-工人详情-查看详情
 */
export const getProjectExternalEmployeeDetail = data => {
  return request(UrlConfig.plusPmWeb.ProjectExternalEmployeeDetail, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人管理-工人详情-合同列表
 */
export const findExtContractByExtEmpId = (current, pageSize, data) => {
  return request(`${UrlConfig.plusPmWeb.FindExtContractByExtEmpId}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 业务组织
 */
export const findOrgList = (data = {}) => {
  return request(UrlConfig.Caas.OrgList, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 业务组织-带权限
 */
export const findOrgTree = (data) => {
  return request(UrlConfig.Caas.OrgTree, {
    method: METHODS.GET,
    data,
  })
}
/**
 * 完整地区树
 */
export const getRegionList = () => {
  return request(UrlConfig.Platform.regionCommons, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 下级地区
 */
export const getRegionChildren = (regionCode) => {
  return request(`${UrlConfig.Platform.regionChildren}/${regionCode}/children`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人-银行卡-列表查询
 */
export const findExtAccountByExtEmpId = (current, pageSize, data) => {
  return request(`${UrlConfig.plusPmWeb.FindExtAccountByExtEmpId}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人管理-工人详情-推荐人查询
 */
export const getEmployee = (current, pageSize, data) => {
  return request(`${UrlConfig.plusPmWeb.searchEmpList}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp?.list
  })
}

export const editFile = (data) => {
  return request(UrlConfig.plusPmWeb.EditFile, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 工人管理-工人详情-查询用户组织
 */
export const searchEmpList = (data) => {
  return request(`${UrlConfig.plusPmWeb.findExtEmpOrgByExtEmpId}`, {
    data: data,
    method: METHODS.POST,
  })
}
/**
 * 工人管理-工人详情-删除用户组织id
 */
export const deleteEmpOrg = (id) => {
  return request(`${UrlConfig.plusPmWeb.deleteEmpOrg}?id=${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 工人管理-工人详情-用户组织启用禁用新增
 */
export const saveOrUpdateEmpOrg = (data) => {
  return request(`${UrlConfig.plusPmWeb.saveOrUpdateEmpOrg}`, {
    method: METHODS.POST,
    data: data
  })
}
/**
 * 工人管理-工人详情-用户组织启用禁用新增
 */
export const syncOutsourcingSyncKd = (data) => {
  const formData = new FormData()
  formData.set('userCode', data.userCode)
  return request(`${UrlConfig.plusPmWeb.SyncOutsourcingSyncKd}`, {
    method: METHODS.POST,
    data: formData
  })
}

/**
 * 工人管理-工人详情-用户组织启用禁用新增
 */
export const manualSendEdoc = (data) => {
  return request(UrlConfig.plusPmWeb.ManualSendEdoc, {
    method: METHODS.POST,
    data: data
  })
}

